import { render } from "./KotlinIcon.vue?vue&type=template&id=c50ed42c&scoped=true"
import script from "./KotlinIcon.vue?vue&type=script&lang=js"
export * from "./KotlinIcon.vue?vue&type=script&lang=js"

import "./KotlinIcon.vue?vue&type=style&index=0&id=c50ed42c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50ed42c"]])

export default __exports__